import React, { ReactNode } from 'react'
import { Box } from '@mui/material'
import { AlertTriangleIcon, ClipboardIcon, ClockIcon, HealthHeartIcon, RefreshCcwIcon } from 'src/designSystem/icons'
import { useSidebarControls } from 'src/designSystem/Container/sidebarControls'
import { PrioritySelectionChange } from './participantListAnalytics'
import { PRIORITY_FILTERS, PRIORITY_FILTER_LABELS, PriorityFilter, PriorityFilterCounts } from './priorityFilterUtils'
import PriorityFilterChip from './PriorityFilterChip'

const filterIcons: Record<PriorityFilter, ReactNode> = {
  safety: <AlertTriangleIcon />,
  reEngage: <RefreshCcwIcon />,
  followUp: <ClipboardIcon />,
  waiting: <ClockIcon />,
  onTrack: <HealthHeartIcon />,
}

type Props = {
  counts: PriorityFilterCounts
  selectedFilters: Array<PriorityFilter>
  onChange: (selectedFilters: Array<PriorityFilter>, change: PrioritySelectionChange) => void
}

const PriorityFilters = ({ counts, selectedFilters, onChange }: Props) => {
  const { isExpanded } = useSidebarControls()

  const toggleFilter = (filter: PriorityFilter) => () => {
    const selected = !selectedFilters.includes(filter)
    // One group at a time: selecting a pill replaces the current selection.
    onChange(selected ? [filter] : [], { priority: filter, selected })
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {PRIORITY_FILTERS.map((filter) => (
        <PriorityFilterChip
          key={filter}
          label={PRIORITY_FILTER_LABELS[filter]}
          icon={filterIcons[filter]}
          count={counts[filter]}
          selected={selectedFilters.includes(filter)}
          expanded={isExpanded}
          onClick={toggleFilter(filter)}
        />
      ))}
    </Box>
  )
}

export default PriorityFilters
